import axios from 'axios'

export const SERVERS_HAS_ERROR = 'SERVERS_HAS_ERROR'
export const SERVERS_IS_LOADING = 'SERVERS_IS_LOADING'
export const SERVERS_FETCH_DATA_SUCCESS = 'SERVERS_FETCH_DATA_SUCCESS'
export const SERVERS_CREATE_CACHE = 'SERVERS_CREATE_CACHE'

export function serversHasError(err) {
    return {
        type: SERVERS_HAS_ERROR,
        error: err
    };
}

export function serversIsLoading(bool) {
    return {
        type: SERVERS_IS_LOADING,
        isLoading: bool
    };
}

export function serversFetchDataSuccess(servers) {
    return {
        type: SERVERS_FETCH_DATA_SUCCESS,
        servers
    };
}

export function serversCreateCache(servers) {
    var serversCache = servers.reduce(function(hash, value) {
        var key = value['id'];
        hash[key] = value.name;
        return hash;
      }, {});

    return {
        type: SERVERS_CREATE_CACHE,
        serversCache
    };
}

async function getData() {
    const res = await axios("/servers_settings?sort=name");
    return res.data;
  }

export function fetchServers() {
    return (dispatch) => {
        dispatch(serversIsLoading(true));

        getData()
        .then(response => {
            dispatch(serversIsLoading(false));
            dispatch(serversFetchDataSuccess(response));
            dispatch(serversCreateCache(response));
        })
        .catch(err => 
        {
            dispatch(serversHasError(err));
        })
        }
    }

